import { Scale } from "../../utils/Scale"

export class Ecig101Pos {

    static ecigsTextY = () => Scale.height() * 0.8

    static packCigarettesX = () => Scale.width() * 0.302
    static packCigarettesY = () => Scale.height() * 0.48

    static otherCigPackX = () => Scale.width() * 0.15

    static matchX = () => Scale.width() * 0.4
    static matchY = () => Scale.height() * 0.65

    static lightableCigX = () => Scale.width() * 0.38
    static lightableCigY = () => Scale.height() * 0.15

    static vapePenY = () => Scale.height() * 0.15

    static vapePenPartsY = () => Scale.height() * 0.475

    static cartridgeX = () => Scale.width() * 0.47

    static mouthPieceX2 = () => Scale.width() * 0.14

    static cartridgeX2 = () => Scale.width() * 0.375

    static heatingElementX2 = () => Scale.width() * 0.51

    static batteriesX2 = () => Scale.width() * 0.8

    static partTitleY = () => Scale.height() * 0.9

    static vape2X = () => Scale.width() * 0.321
    static vape2Y = () => Scale.height() * 0.53

    static skipButtonX = () => Scale.width() * 0.75
    static skipButtonY = () => Scale.height() * 0.02

    static secondEcigsX = () => Scale.width() * 0.1

    static exitLabelsY = () => Scale.height() * 0.8
}
